export { default } from "./src/text-with-icon";
export type { UniformTextWithIconProps } from "./src/text-with-icon";
